import { z } from "zod";
import apiMaterialSchema from "./apiMaterialSchema";

const apiSvgMaterialSchema = apiMaterialSchema.extend({
    url: z.string()    
  });

export default apiSvgMaterialSchema;